<template>
    <div>
         <div style="font-size:18px;width:98%">
             <el-row :gutter="20">
                 <el-col :span="4">
                总工时：{{userReportData.spentTime | hoursToDays}}
                </el-col>
                <el-col :span="4">
                项目工时：{{userReportData.projectSpentTime | hoursToDays}}
                </el-col>
                <el-col :span="4">
                任务工时：{{userReportData.taskSpentTime | hoursToDays}}
                </el-col>
                <el-col :span="12">
                
                </el-col>
            </el-row>
         </div>
        <div style="margin-top:30px;">
             <div id="monthlySpentTimeChart" :style="{width: '98%', height: '300px'}"></div>
        </div>
        <div style="margin-top:30px;width:98%">
             <!-- <el-row :gutter="0">
                 <el-col :span="12">
                      <div id="projectAndUserSpentTimeChart" :style="{width: '98%', height: '300px'}"></div>
                </el-col>
                <el-col :span="12">
                
                </el-col>
            </el-row> -->
            <div id="projectAndUserSpentTimeChart" :style="{width: '98%', height: '300px'}"></div>
         </div>
    </div>
</template>


<script>
export default {
  name: "userReportDialog_Collect",
  props: ["userReportDialogChildProps"],
  data() {
    return {
         workingHours:window.Glob.WorkingHours,
     // userId:this.userReportDialogChildProps.userId,
      projectMonthlySpentTimeData:null,
      getMonthlySpentTimeDataTableGroupByProjectArgs:null,
      taskMonthlySpentTimeData:null,
      userReportData:{
          spentTime:null,
          projectSpentTime:null,
          taskSpentTime:null
      },
      getUserReportDataArgs:null,
      monthArray:[],
      projectSpentTimeArray:[],
      taskSpentTimeArray:[]
    };
  },
  mounted(){

    //this.clear();
    //this.show();

   // this.drawOrganizationSpentTimeChart();
  },
  methods: {
    clear(){
        this.userReportData = {
          spentTime:null,
          projectSpentTime:null,
          taskSpentTime:null
        };

        this.monthArray = [];
        this.projectSpentTimeArray = [];
        this.taskSpentTimeArray = [];

        let monthlySpentTimeChart = this.$echarts.init(document.getElementById('monthlySpentTimeChart'));
        monthlySpentTimeChart.clear();
        let projectAndUserSpentTimeChart = this.$echarts.init(document.getElementById('projectAndUserSpentTimeChart'));
        projectAndUserSpentTimeChart.clear();
    },
    show(){

        this.getUserReportData();

        //https://echarts.apache.org/examples/zh/editor.html?c=bar-stack
        this.getMonthlySpentTime();

       // alert(this.userReportDialogChildProps.userId);
    },

    getUserReportData(){
        this.getUserReportDataArgs = {
                userId: this.userReportDialogChildProps.userId,
                startYear: "",
                startMonth: "",
                endYear: "",
                endMonth: ""
            }

         this.$reportApi.getUserReportData(this.getUserReportDataArgs).then(res => {
          if (res.data.successful) {
            this.userReportData = res.data.data;

            this.drawProjectAndTaskSpentTimeChart();

          } else {
            this.$alert(res.data.message, "提示");
          }
         });
    },

    getMonthlySpentTime(){
        this.getMonthlySpentTimeDataTableGroupByProjectArgs = {
            PagingInfo: {
                currentPage: 1,
                totalPage: 0,
                pageSize: 10,
                totalCount: 0
            },
            OrderBy: "",
            Parameters: {
                userId: this.userReportDialogChildProps.userId,
                startYear: "",
                startMonth: "",
                endYear: "",
                endMonth: ""
            }
        };

         this.$reportApi.getMonthlySpentTimeDataTableGroupByAllProject(this.getMonthlySpentTimeDataTableGroupByProjectArgs).then(res => {
          if (res.data.successful) {
            this.projectMonthlySpentTimeData = res.data.data.data[0];
            
            this.$reportApi.getMonthlySpentTimeDataTableGroupByAllTask(this.getMonthlySpentTimeDataTableGroupByProjectArgs).then(res => {
            if (res.data.successful) {
                this.taskMonthlySpentTimeData = res.data.data.data[0];

                this.processMonthlyItem();
                this.drawMonthlySpentTimeChart();

            } else {
                this.$alert(res.data.message, "提示");
            }});
            

          } else {
            this.$alert(res.data.message, "提示");
          }});
    },

    //对齐两组数据的年月，如：
    //{"-2020-4":"1","-2020-5":"5","-2020-6":"20"}
    //{"-2020-5":"5","-2020-6":"1"}
    processMonthlyItem(){

        let projectStartAttr = "";
        let projectEndAttr = "";
        for(let key in this.projectMonthlySpentTimeData)
                {
                    if(key.indexOf('-') !='-1')
                    {
                        if(projectStartAttr == "")
                            projectStartAttr = key.substring(1);

                        projectEndAttr = key.substring(1);
                    }
                };

        let projectStartYear = "";
        let projectStartMonth = "";
        let projectEndYear = "";
        let projectEndMonth = "";
        if(projectStartAttr!= "")
        {
            projectStartYear = projectStartAttr.substring(0,projectStartAttr.indexOf("-"));
            projectStartMonth = projectStartAttr.substring(projectStartAttr.indexOf("-") + 1);
            projectEndYear = projectEndAttr.substring(0,projectEndAttr.indexOf("-"));
            projectEndMonth = projectEndAttr.substring(projectEndAttr.indexOf("-") + 1);
        }

        let taskStartAttr = "";
        let taskEndAttr = "";
        for(let key in this.taskMonthlySpentTimeData)
                {
                    if(key.indexOf('-') !='-1')
                    {
                        if(taskStartAttr == "")
                            taskStartAttr = key.substring(1);

                        taskEndAttr = key.substring(1);
                    }
                };

        let taskStartYear = "";
        let taskStartMonth = "";
        let taskEndYear = "";
        let taskEndMonth = "";
        if(taskStartAttr!= "")
        {
            taskStartYear = taskStartAttr.substring(0,taskStartAttr.indexOf("-"));
            taskStartMonth = taskStartAttr.substring(taskStartAttr.indexOf("-") + 1);
            taskEndYear = taskEndAttr.substring(0,taskEndAttr.indexOf("-"));
            taskEndMonth = taskEndAttr.substring(taskEndAttr.indexOf("-") + 1);
        }

        if(projectStartAttr == "" && taskStartAttr == "")
        {
            return;
        }
        else if(projectStartAttr == "")
        {
            for(let key in this.taskMonthlySpentTimeData)
            {
                    if(key.indexOf('-') !='-1')
                    {
                        this.monthArray.push(key.substring(1));
                        this.taskSpentTimeArray.push(
                            (this.taskMonthlySpentTimeData[key]/this.workingHours).toFixed(1)
                            );
                    }
                };

            return;
        }
        else if(taskStartAttr == "")
        {
            for(let key in this.projectMonthlySpentTimeData)
            {
                    if(key.indexOf('-') !='-1')
                    {
                        this.monthArray.push(key.substring(1));
                        this.projectSpentTimeArray.push(
                            (this.projectMonthlySpentTimeData[key]/this.workingHours).toFixed(1)
                            );
                    }
                };

            return;
        }

        let startYear = projectStartYear;
        let startMonth = projectStartMonth;
        if(taskStartYear < projectStartYear)
        {
            startYear = taskStartYear;
            startMonth = taskStartMonth;
        }
        else if(taskStartYear == projectStartYear)
        {
            if(taskStartMonth < projectStartMonth)
            {
                startMonth = taskStartMonth;
            }
        }

        let endYear = projectEndYear;
        let endMonth = projectEndMonth;
        if(taskEndYear > projectEndYear)
        {
            endYear = taskEndYear;
        }
        else if(taskEndYear == projectEndYear)
        {
            if(taskEndMonth > projectEndMonth)
            {
                endMonth = taskEndMonth;
            }
        }

        for (var i = startYear; i <= endYear; i++)
        {
            var j = startMonth;
            if(i==startYear)
            {
                j = startMonth;
            }
            else if(i <= endYear)
            {
                j=1;
            }

            while(true)
            {
                var month = i + "-" + j;
                this.monthArray.push(month);
                month = "-" + i + "-" + j;

                //项目
                if(this.projectMonthlySpentTimeData[month])
                {
                    this.projectSpentTimeArray.push(
                        (this.projectMonthlySpentTimeData[month]/this.workingHours).toFixed(1)
                        );
                }
                else{
                    this.projectSpentTimeArray.push(0);
                }

                //任务
                if(this.taskMonthlySpentTimeData[month])
                {
                    this.taskSpentTimeArray.push(
                        (this.taskMonthlySpentTimeData[month]/this.workingHours).toFixed(1)
                        );
                }
                else{
                    this.taskSpentTimeArray.push(0);
                }

                if(i==endYear)
                {
                    if(j==endMonth)
                    {
                        break;
                    }
                    else
                    {
                        j++;
                    }
                }
                else if(i < endYear)
                {
                    if(j==12)
                    {
                        break;
                    }
                    else
                    {
                        j++;
                    }
                }
            }
        }
    },

    drawMonthlySpentTimeChart(){

        // 基于准备好的dom，初始化echarts实例
        let monthlySpentTimeChart = this.$echarts.init(document.getElementById('monthlySpentTimeChart'))
        // 绘制图表
        let option = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                    type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                }
            },
            legend: {
                data: ['任务', '项目']
            },
            grid: {
                left: '3%',
                right: '4%',
                bottom: '3%',
                containLabel: true
            },
            xAxis: [
                {
                    type: 'category',
                    data: this.monthArray
                }
            ],
            yAxis: [
                {
                    type: 'value'
                }
            ],
            series: [
            
                {
                    name: '任务',
                    type: 'bar',
                    stack: '工时',
                    data: this.taskSpentTimeArray
                },
                {
                    name: '项目',
                    type: 'bar',
                    stack: '工时',
                    data: this.projectSpentTimeArray
                }
            ]
        };

        monthlySpentTimeChart.setOption(option);
    },

    drawProjectAndTaskSpentTimeChart(){
        
         //准备X轴的月份和要显示的数据
        let organizationArray = ["任务","项目"];
        let organizationSpentTimeArray = [];
        organizationSpentTimeArray.push(
                        {
                            name:"任务",
                            value:(this.userReportData.taskSpentTime / this.workingHours).toFixed(1)
                        }
                    );
        organizationSpentTimeArray.push(
                        {
                            name:"项目",
                            value:(this.userReportData.projectSpentTime/ this.workingHours).toFixed(1)
                        }
                    );

        // 基于准备好的dom，初始化echarts实例
        let projectAndUserSpentTimeChart = this.$echarts.init(document.getElementById('projectAndUserSpentTimeChart'))
        // 绘制图表
        projectAndUserSpentTimeChart.setOption(
           {
                title: {
                    text: '工时统计',
                  //  subtext: '纯属虚构',
                    left: 'center'
                },
                tooltip: {
                    trigger: 'item',
                    formatter: '{a} <br/>{b} : {c} ({d}%)'
                },
                legend: {
                    type: 'scroll',
                    orient: 'vertical',
                    right: 10,
                    top: 20,
                    bottom: 20,
                    data: organizationArray,
                   // selected: data.selected
                },
                series: [
                    {
                        name: '',
                        type: 'pie',
                        radius: '55%',
                        center: ['40%', '50%'],
                        data: organizationSpentTimeArray,
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                        },
                        label: {
                            formatter: '{hr|}\n  {b|{b}：}{c}  {per|{d}%}  ',
                            backgroundColor: '#eee',
                            borderColor: '#aaa',
                            borderWidth: 1,
                            borderRadius: 4,
                            // shadowBlur:3,
                            // shadowOffsetX: 2,
                            // shadowOffsetY: 2,
                            // shadowColor: '#999',
                            // padding: [0, 7],
                            rich: {
                                hr: {
                                    borderColor: '#aaa',
                                    width: '100%',
                                    borderWidth: 0.5,
                                    height: 0
                                },
                                b: {
                                    fontSize: 16,
                                    lineHeight: 33
                                },
                                per: {
                                    color: '#eee',
                                    backgroundColor: '#334455',
                                    padding: [2, 4],
                                    borderRadius: 2
                                }
                            }
                        },
                    }
                ]
            }
        );}
    }
};
</script>

<style  rel="stylesheet/scss" lang="scss">


</style>


// WEBPACK FOOTER //
// src/views/report/userReportDialog_Collect.vue